import React, { useState } from 'react';
import {
  AppCard, AppModal, AppMultiSelect, AppRemixIcon,
} from '@/layout/AppComponents';
import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../../constants/colors';
import Translator from '../../../../../../components/helpers/Translator'; import ChangeBlockEvidenceCloneForm from './ChangeBlockEvidenceCloneForm';

const ChangeBlockEvidenceClone = (props) => {
  const { handleAddEvidence, value } = props;
  const [showCloneEvidenceModal, setShowCloneEvidenceModal] = useState(false);
  return (
    <>
      <span
        className="btn btn-block btn-sm btn-outline-light mb-2"
        onClick={() => setShowCloneEvidenceModal(true)}
      >
        <Translator file="module-legalCompliance" name="clone.evidence" />
      </span>
      {value.length === 0
        ? <small><Translator file="module-legalCompliance" name="clone.evidence.description" /></small>
        : (
          <AppCard>
            <EvidenceElement>
              <span>
                <Translator file="module-legalCompliance" name="clone.evidence.selected" variables={{ numberOfEvidences: value.length }} />
              </span>
              <AppRemixIcon
                icon="delete-bin"
                color={colors.danger}
                onClick={() => handleAddEvidence([])}
                title={ReactDOMServer.renderToString(<Translator file="user" name="user.remove" />)}
                className="pointer"
              />
            </EvidenceElement>

          </AppCard>
        )}

      <AppModal
        show={showCloneEvidenceModal}
        title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="clone.evidence" />)}
        onClose={() => setShowCloneEvidenceModal(false)}
        onConfirm={() => setShowCloneEvidenceModal(false)}
        isConfirmBtn
        confirmBtnText={ReactDOMServer.renderToString(<Translator file="user" name="user.accept" />)}
        size="lg"
      >
        <ChangeBlockEvidenceCloneForm handleCloneEvidence={handleAddEvidence} value={value} />
      </AppModal>
    </>
  );
};
export default ChangeBlockEvidenceClone;

const EvidenceElement = styled.div`
  display: grid;
  grid-template-columns: 1fr 20px;
`;
